export default "__VITE_ASSET__B9ADB6yS__"